import React from 'react'
import Head from 'next/head'
import Pitch from '@src/components/DisposalPage/Pitch'
import FeatureList from '@src/components/DisposalPage/FeatureList'
import Approach from '@src/components/DisposalPage/Approach'
import CaseStudy from '@src/components/DisposalPage/CaseStudy'
import FAQ from '@src/components/DisposalPage/FAQ'
import SustainabilityDashboardPromo from '@src/components/DisposalPage/SustainabilityDashboardPromo'
import SchemaMarkup from '@src/components/SchemaMarkup'
import RelatedServices from '@src/components/RelatedServices'
import Clients from '@src/pages/LandingPage/Clients'
import TrustBox from '@src/pages/common/components/TrustBox'
import TrustedByClients from '@src/components/DisposalPage/TrustedByClients'
import pageClasses from '@src/styles/sharps-disposal-page.module.css'
// eslint-disable-next-line import/extensions
import sharps from '../../json/sharps-disposal-data.json'

const sharpsServiceData = {
  name: 'Sharps Disposal',
  description:
    'Business-only pickup and disposal of sealed sharps containers for medical facilities and other commercial customers, with DOT- and RCRA-compliant transport and full documentation. Not available for residential customers.',
  serviceType: 'Sharps Disposal',
  url: 'https://getdimension.com/sharps-disposal',
  provider: {
    name: 'Dimension',
    url: 'https://getdimension.com',
    address: {
      streetAddress: '2261 Market Street, #4061',
      addressLocality: 'San Francisco',
      addressRegion: 'CA',
      postalCode: '94114',
      addressCountry: 'US',
    },
    telephone: '+1 (415) 340-7182',
  },
  offers: [
    { name: 'Sharps Container Pickup' },
    { name: 'Recurring Sharps Pickup Program' },
    { name: 'Multi-Site Sharps Collection' },
  ],
}

const sharpsFAQData = {
  questions: sharps.FAQContent.contentList.map((faq) => ({
    question: faq.heading.replace(/<[^>]*>/g, ''),
    answer: faq.textList.join(' '),
  })),
}

function SharpsDisposal() {
  return (
    <>
      <Head>
        <title>Sharps Disposal for Businesses &amp; Medical Facilities | Dimension</title>
        <meta
          name="description"
          content="Business sharps disposal — scheduled pickup of sealed sharps containers with DOT/RCRA-compliant transport and full documentation. Instant quote. Commercial customers only."
        />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <link rel="canonical" href="https://getdimension.com/sharps-disposal" />
        <SchemaMarkup type="WebSite" />
        <SchemaMarkup type="Service" data={sharpsServiceData} />
        <SchemaMarkup type="FAQPage" data={sharpsFAQData} />
        <SchemaMarkup type="LocalBusiness" />
      </Head>
      <div className={pageClasses.root}>
        <Pitch
          variant="hazardous-waste"
          heading={sharps.pitch.heading}
          material={sharps.pitch.material}
          pitchText={sharps.pitch.pitchText}
          ctaLink={sharps.pitch.ctaLink}
          ctaText={sharps.pitch.ctaText}
          belowCta={<TrustBox isMobile isDark={false} />}
          belowPitch={<TrustedByClients />}
        />
        <Clients />
        <FeatureList {...sharps.solutions} />
        <SustainabilityDashboardPromo />
        <FeatureList {...sharps.benefits} />
        <CaseStudy {...sharps.caseStudy} />
        <Approach {...sharps.approach} />
        <FAQ {...sharps.FAQContent} />
        <RelatedServices
          services={[
            {
              label: 'Medical and Laboratory Waste Disposal',
              href: '/medical-waste-disposal',
              description:
                'Business pickup of medical and lab debris and sharps with compliant transport and documentation.',
            },
            {
              label: 'Hazardous Waste Disposal',
              href: '/hazardous-waste-disposal',
              description:
                'Safe disposal of chemical waste, solvents, and other hazardous materials for businesses.',
            },
            {
              label: 'Lab Pack Services',
              href: '/lab-pack-services',
              description:
                'Chemist-led identification, segregation, and pack-out of small-container laboratory chemicals.',
            },
            {
              label: 'Regulated Waste Disposal',
              href: '/regulated-waste-disposal',
              description:
                'The catch-all for EPA- and DOT-regulated materials — universal waste, batteries, aerosols, gases, and more.',
            },
          ]}
        />
      </div>
    </>
  )
}

export default SharpsDisposal
